import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { Headset } from "lucide-react";

import { clx } from "../../../utils/Helpers";

import "./CustomPlanBanner.scss";

/** "Custom Plan" note: more than the biggest crew size goes through the sales team. */
const CustomPlanBanner = ({ title, message, variant, className }) => (
  <div
    className={clx(
      "custom-plan-banner",
      `custom-plan-banner--${variant}`,
      className,
    )}
  >
    <span className="custom-plan-banner__icon">
      <Headset size={20} aria-hidden />
    </span>
    <div className="custom-plan-banner__copy">
      <Typography component="h3" className="text-heading-sm custom-plan-banner__title">
        {title}
      </Typography>
      <Typography component="p" className="text-body-sm custom-plan-banner__message">
        {message}
      </Typography>
    </div>
  </div>
);

CustomPlanBanner.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  /** card: bordered on the page (Crew Size step); subtle: filled, inside a popup. */
  variant: PropTypes.oneOf(["card", "subtle"]),
  className: PropTypes.string,
};

CustomPlanBanner.defaultProps = {
  variant: "card",
  className: undefined,
};

export default CustomPlanBanner;
